import { useQuery } from '@tanstack/react-query'
import { assistantBookingService } from '@/api/services/assistantBookingService'
import type { AssistantPayment } from '@/api/services/assistantBookingService'

export function useAssistantPaymentList(p?: Parameters<typeof assistantBookingService.paymentList>[0]) {
  return useQuery({
    queryKey: ['assistant-bookings', 'payment-list', p],
    queryFn: () => assistantBookingService.paymentList(p),
    staleTime: 30_000,
  })
}

// The list endpoint only supports filtering to one status at a time
// (is_approved: 1 = approved, 2 = pending) — there's no "all" mode. The
// Assistant Bookings page no longer splits these into separate tabs, so this
// fetches both and merges them into one feed, newest first.
export function useAssistantPaymentListAll(limit = 100) {
  const pending = useAssistantPaymentList({ page: 1, limit, is_approved: 2 })
  const approved = useAssistantPaymentList({ page: 1, limit, is_approved: 1 })

  const rows: AssistantPayment[] = [...(pending.data?.data ?? []), ...(approved.data?.data ?? [])]
    .sort((a, b) => new Date(b.created_at ?? 0).getTime() - new Date(a.created_at ?? 0).getTime())

  return {
    rows,
    total: (pending.data?.total ?? 0) + (approved.data?.total ?? 0),
    isLoading: pending.isLoading || approved.isLoading,
    isError: pending.isError || approved.isError,
  }
}
